import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const OnboardAssessmentDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsOnboardAssessmentDetails" */ 'modules/activityDetails/OnboardAssessmentDetails/pages/OnboardAssessmentDetails'
    )
)

const OnboardAssessmentDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:competenceId/:assessmentId`}
        component={OnboardAssessmentDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default OnboardAssessmentDetailsRouting
